/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize VaccineScheduling List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './VaccineSchedulingListView';

export const mapStateToPropsVaccineSchedulingList = mapStateToProps;
export const mapDispatchToPropsVaccineSchedulingList = mapDispatchToProps;

export default connect(
  mapStateToPropsVaccineSchedulingList,
  mapDispatchToPropsVaccineSchedulingList
)(View);
